export const BffRoute = {
  RastreamentoPublico: (token: string) => `/tracking?token=${token}`
}
